import Swiper, { Navigation } from 'swiper'

$.fn.ThumbnailGallery = function() {
  let self = this

  if (self.data('thumbnail-gallery')) {
    return self.data('thumbnail-gallery')
  }

  self.carousel = undefined
  self.is_transitioning = false
  self.is_buffering = false
  self.is_dragging = false
  self.current_index = 0
  self.max_index = self.find('.swiper-slide').length - 1
  self.viewer = self.find('.thumbnail-gallery__main')

  self.switch_to_picture = function(thumbnail) {
    if (self.is_transitioning) {
      self.is_buffering = thumbnail
      return
    }
    self.is_transitioning = true
    if (thumbnail.attr('data-bg-color')) {
      self.css('--gallery-bg', thumbnail.attr('data-bg-color'))
    }
    self.viewer.css('height', self.viewer.outerHeight(false) + 'px')
    let old_picture = self.viewer.find('.picture'),
    new_picture = thumbnail.find('.picture[class*="gallery-picture"]').clone()
    old_picture.addClass('--transitioning')
    new_picture.addClass('--transitioning')
    self.viewer.append(new_picture)
    let targetHeight = new_picture.outerHeight(false)
    new_picture.hide()
    requestAnimationFrame(function() {
      old_picture.fadeOut(150)
      self.viewer.animate({
        height: targetHeight + 'px',
      }, 375, 'easeInOutQuart')
      setTimeout(function() {
        new_picture.fadeIn(350, function() {
          new_picture.removeClass('--transitioning')
          old_picture.remove()
          self.viewer.css('height', '')
          self.is_transitioning = false
          if (self.is_buffering) {
            self.switch_to_picture(self.is_buffering)
            self.is_buffering = false
          }
        })
      }, 250)
    })
  }

  self.initialize = function() {
    /* Select first thumbnail on load */
    self.find('.swiper-slide').first().addClass('thumbnail-active')

    /* Click previous */
    self.find('.swiper-button-prev').on('click', function(e) {
      if (self.carousel != undefined  && self.carousel.animating) {
        return false
      }
      self.current_index -= 1
      if (self.current_index < 0) {
        self.current_index = self.max_index
      }
      if (self.carousel == undefined) {
        self.find('.swiper-slide:eq(' + self.current_index + ') .gallery-thumbnail').trigger('click')
      } else {
        $('.swiper-slide[data-swiper-slide-index="' + self.current_index + '"]:not(.swiper-slide-duplicate) .gallery-thumbnail').trigger('click')
      }
    })

    /* Click next */
    self.find('.swiper-button-next').on('click', function(e) {
      if (self.carousel != undefined && self.carousel.animating) {
        return false
      }
      self.current_index += 1
      if (self.current_index > self.max_index) {
        self.current_index = 0
      }
      if (self.carousel == undefined) {
        self.find('.swiper-slide:eq(' + self.current_index + ') .gallery-thumbnail').trigger('click')
      } else {
        $('.swiper-slide[data-swiper-slide-index="' + self.current_index + '"]:not(.swiper-slide-duplicate) .gallery-thumbnail').trigger('click')
      }
    })

    $('.thumbnail-gallery__fancy__link').fancybox({
      baseClass: '--product-gallery',
      zoom: false,
      btnTpl: {
        arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
        + '<i class="icon-chevron-up"></i>'
        + '</button>',
        arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
        + '<i class="icon-chevron-up"></i>'
        + '</button>'
      },
      buttons: ['close', 'slideshow'],
      caption: function(instance, item) {
        return $('.thumbnail-gallery__fancy-content').html(); // Fetch caption from data attribute
      },
      afterShow: function(instance, current) {
         instance.$refs.container.find('.js-add-to-cart').click(function() {
           $.fancybox.close();
           $('.single-product-page__summary button[type="submit"]').trigger('click')
           return false;
         })
      }
    });

    /* Maybe initialize thumbnails carousel */
    if (self.hasClass('thumbnail-gallery--carousel')) {
      self.carousel = new Swiper(self.find('.swiper-container').get(0), {
        modules: [ Navigation ],
        loop: true,
        slidesPerView: 6,
        spaceBetween: 0,
        direction: 'vertical',
        threshold: 15,
        resistanceRatio: 0.25,
        breakpoints: {
          768: {
            slidesPerView: 7,
          },
        },
        navigation: {
          enabled: true,
          nextEl: self.find('.swiper-button-next').get(0),
          prevEl: self.find('.swiper-button-prev').get(0),
        },
      })

      self.carousel.on('sliderFirstMove', function() {
        self.is_dragging = true
      })

      self.carousel.on('transitionEnd', function() {
        if (self.is_dragging) {
          self.is_dragging = false
          self.find('.swiper-slide[data-swiper-slide-index="' + self.carousel.realIndex + '"]:not(.swiper-slide-duplicate) .gallery-thumbnail').trigger('click')
        }
      })
    }

    /* Click on main image */
    self.find('.thumbnail-gallery__main').click(function() {
      self.find('.thumbnail-gallery__fancy a[data-id=' + self.attr('data-current-id') + ']').trigger('click')
    })

    /* Click on thumbnail */
    self.on('click', '.gallery-thumbnail', function(e) {
      e.preventDefault()
      self.attr('data-current-id', $(this).attr('data-id'))

      if ($(this).closest('.swiper-slide').hasClass('thumbnail-active')) {
        return
      }
      $('.thumbnail-active').removeClass('thumbnail-active')
      $(this).closest('.swiper-slide').addClass('thumbnail-active')
      if ($(this).closest('.swiper-slide').attr('data-swiper-slide-index') != undefined) {
        let slideIndex = parseInt($(this).closest('.swiper-slide').attr('data-swiper-slide-index'), 10)
        self.current_index = slideIndex
        self.find('.swiper-slide[data-swiper-slide-index="' + slideIndex + '"]').addClass('thumbnail-active')
      } else {
        self.current_index = $(this).closest('.swiper-slide').index()
      }
      self.switch_to_picture($(this))
    })
  }

  self.toggle_mobile = function() {
    $('.single-product-page__mobile-gallery').append(self.detach())
    if (self.carousel) {
      self.carousel.update()
    }
    self.min_height()
  }

  self.toggle_desktop = function() {
    $('.single-product-page__preview-wrapper').append(self.detach())
    if (self.carousel) {
      self.carousel.update()
    }
    self.min_height()
  }

  self.min_height = function() {
    let arrows_height = self.find('.swiper-button-next').length ? 36 : 0
    self.css({
      'min-height': Math.round(self.find('.swiper-container').height() + parseFloat(self.find('.swiper-container').css('top')) - 6 + arrows_height) + 'px',
    })
  }

  return function() {
    $.mlmi.mobile.add(self.toggle_mobile, self.toggle_desktop)
    self.initialize()
    $(window).on('resize load orientationchange', self.min_height)
    self.min_height()
    self.data('thumbnail-gallery', self)
    return self
  }()
}
